<script lang="tsx" setup>
import type { KirbyBlock } from "@/queries/blocks"
import BlockPreviews from "@/components/BlockPreviews/index.vue"
import { cleanHTML } from "@/utils/clean"
import { ref, watch } from "vue"

const props = defineProps<{
  blocks: KirbyBlock[]
  active: boolean
}>()

const emit = defineEmits<{
  open: [index: number]
}>()

const caption = ref("")

watch(
  () => props.active,
  () => {
    caption.value = ""
  },
)
</script>

<template>
  <section class="px-4 py-3 pt-12">
    <div
      class="grid grid-cols-3 lg:gap-24 gap-4 lg:gap-y-4 2xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3"
    >
      <BlockPreviews
        :blocks="props.blocks"
        @open="emit('open', $event)"
        @caption-change="caption = $event"
      />
    </div>
    <!-- <Transition name="caption-fade" mode="out-in">
      <div
        v-if="caption"
        :key="caption"
        class="py-4 text-center small px-4 body-text text-black"
      >
        <div class="mx-auto text-sm lg:max-w-2/4" v-html="cleanHTML(caption)" />
      </div>
    </Transition> -->
  </section>
</template>

<style scoped>
.caption-fade-enter-active,
.caption-fade-leave-active {
  transition: opacity 220ms ease;
}

.caption-fade-enter-from,
.caption-fade-leave-to {
  opacity: 0;
}
</style>
